import { useChatStateStore } from "../zustand/store";
import { contents } from "../data/contents";
import styles from '../style/styles/ErrorPage.module.css';

const ErrorPage = () => {
    const { language } = useChatStateStore();
    return (
        <div className={styles.ErrorPage__container}>
            <img src='img/units/searching-anime.gif' alt='searching-anime' style={{ width: '75%' }}/>
            <div className='spacing-16'/>
            <p className='h3 fc-gray-900' style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>{contents.message[language].errorPage}</p>
            <div className='spacing-24'/>
            {/* refresh button */}
            <div 
                className={styles.ErrorPage__refreshBtn}
                onClick={() => {
                    window.parent.location.reload();
                }}
            >
                <p className='h7 fc-gray-900'>{contents.message[language].refresh}</p>
            </div>
        </div>
    )
}

export default ErrorPage;